import * as THREE from "three";
import { InputItem, TouchItem } from './gizmo';
import { Board } from './gameMain';
import { Blob, BlobSize, BlobStatus } from './gameBlob';
import SoundManager from "../soundManager";

enum EntityCategory {
    BOUNDARY = 0x0001,
    BLOB = 0x0002,
    OBSTACLE = 0x0004,
};
export default class NOBCMain {
    public OnBubbleShow!: () => void;
    public OnStart!: () => void;
    public OnDead!: (type: number) => boolean;
    public OnBlobEventInfo!: (type: number) => void;


    public board!: Board;
    public blob!: Blob;

    public maxObject = 3;
    public radius = 1;
    public blobRadius = 0.3;
    public timeout = 500;
    public isGameStarted = false;
    public isDead = false;
    private ccBonus = 1.0;
    private inputs = new Map<number, InputItem>();
    private guideColors = [new THREE.Color(0xff9e9e), new THREE.Color(0x9ecbff), new THREE.Color(0x9cffbc), new THREE.Color(0x35ac92), new THREE.Color(0x28fc4)];
    //private touches = new Map<number, TouchItem>();
    private objects = new Array<TouchItem>();
    private isDebug: boolean = false;
    //game
    public shouldScroll = false;
    get scrollSpeed(): number {
        return this._scrollSpeed * 10000;
    }
    set scrollSpeed(value: number) {
        this._scrollSpeed = value / 10000;
    }
    public _scrollSpeed = 0.001;
    public scrollPosition = 0;
    public cc = 0;
    public life = 3;
    constructor(private scene: THREE.Scene, private sceneNoEffect: THREE.Scene, private targetWidth: number, private targetHeight: number, private camera: THREE.OrthographicCamera) {

    }

    public updateScene(): void {
        const points = [];

        for (const item of this.objects) {
            item.update(0);
            points.push(new THREE.Vector3(item.circle.position.x, item.circle.position.y, 0));
        }
        if (points.length > 2) {
            points.push(new THREE.Vector3(points[0].x, points[0].y, 0));
        }

        if (points.length > 2) {
            if (!this.isGameStarted) {

                this.StartGame();
                this.blob.SetInit();
            }
            this.blob.SetPoints(points);
            this.blob.IsAllTouchOn = true;
        } else {
            this.blob.IsAllTouchOn = false;
        }
        if (this.shouldScroll) {
            let speed = this._scrollSpeed * 1.5;
            if (this.blob.blobSize == BlobSize.BIG) {
                speed *= 0.5;
            } else if (this.blob.blobSize == BlobSize.SMALL) {
                speed *= 1.5;
            }
            this.cc += speed * 10000 * this.ccBonus;
            this.cc = Math.round(this.cc);
            this.scrollPosition += speed;
            this.board.AddYOffset(speed);
            if (!this.isGameStarted) return;
            if (this.blob.GetStatus() == BlobStatus.NORMAL || this.blob.GetStatus() == BlobStatus.UNSTABLE) {
                const IsHit = this.board.HitTest(this.blob.shapePointsBig);
                this.blob.SetHit(IsHit);
                if (IsHit) this.Play("fart_" + this.randomIntFromInterval(1, 6));
            }
            this.board.CheckCollider(this.blob.shapePointsBig, this.blob.centerPoint);
        }
    }
    public randomIntFromInterval(min: number, max: number) { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
    private OnBlobEvent(type: number) {
        if (type == 0) {
            this.blob.randomFace();
        } else if (type == 1) {
            //cc
            this.ccBonus = 1.5;
            setTimeout(() => { this.ccBonus = 1.0 }, 5000);
        } else {
            this.blob.SetStatus(BlobStatus.SUPER, true);
        }
        this.OnBlobEventInfo(type);
    }
    public async initScene(): Promise<void> {
        this.board = new Board(this.targetWidth, this.targetHeight);
        this.board.OnBubbleShow = this.OnBubbleShow;
        this.board.OnSound = (key) => { this.Play(key) };


        this.scene.add(this.board);
        this.blob = new Blob();
        this.blob.OnDead = this.OnDead;
        this.scene.add(this.blob);

        this.board.OnBlobEvent = (type) => { this.OnBlobEvent(type); };

    }

    public ToggleDebug() {
        this.board.isDebug = !this.board.isDebug;
        this.isDebug = this.board.isDebug;
    }
    public EndGame() {
        this.shouldScroll = false;
        this.isDead = true;
        this.clearTouches();
    }
    public ResetGame() {
        this.blob.ResetBlob();
        this.board.RemoveAll();
        this.ccBonus = 1.0;
        this.cc = 0;
        this.life = 3;
        this.isDead = false;
        this.scrollPosition = 0;
        this.isGameStarted = false;
    }
    private sounds = [
        'bird',
        'cat',
        'cow',
        //'fart',
        'flower',
        'frog',
        'human',
        'tree'
    ];
    private soundsList: string[] = [];
    private IsSoundInit = false;
    private sound = new Map<string, THREE.Audio>();
    public InitAudio() {
        if (this.IsSoundInit) return;
        this.IsSoundInit = true;
        // create an AudioListener and add it to the camera
        const listener = new THREE.AudioListener();
        this.camera.add(listener);

        for (let i = 0; i < this.sounds.length; i++) {
            for (let j = 1; j < 4; j++) {
                this.soundsList.push(this.sounds[i] + "_" + j);
            }
        }
        for (let j = 1; j < 7; j++) {
            this.soundsList.push("fart_" + j);
        }
        //this.soundsList.push('main');
        this.soundsList.push('ending');
        this.soundsList.push('fartleak_1');
        this.soundsList.push('fartleak_2');
        this.soundsList.push('item_1');
        for (let i = 0; i < this.soundsList.length; i++) {
            // create a global audio source
            const sound = new THREE.Audio(listener);

            const file = "/assets/sounds/" + this.soundsList[i] + ".mp3";
            // load a sound and set it as the Audio object's buffer
            const name = this.soundsList[i]
            const loader = new THREE.AudioLoader();
            loader.load(file, (buffer) => {
                sound.setBuffer(buffer);
                //console.log(name)
                this.sound.set(name, sound);
            });
        }
    }
    public PlayLoop(key: string) {
        const sound = this.sound.get('ending');
        if (key == 'main') {
            SoundManager.playBGM();
            
            if (sound) {
                //console.log("play")
                sound.stop();
            }
        } else {
            SoundManager.stopBGM();
            if (sound) {
                sound.loop = true;
                sound.play();
            }
        }
    }
    public Play(key: string) {
        const sound = this.sound.get(key);
        if (sound) {
            //console.log("play")
            sound.play();
        }
    }
    public StartGame() {
        this.cc = 0;
        this.life = 3;
        this.isGameStarted = true;
        this.shouldScroll = true;
        this.OnStart();
    }

    public handleTouchStart(id: number) {
        if (this.isDead) return;
        //if(!this.board.HitTestItems()){
        if (this.inputs.size < 5) {
            this.inputs.set(id, new InputItem(new THREE.Color(0x666666), this.isDebug));
            this.scene.add(this.inputs.get(id)!.line);
        }
        //}
    }

    public handleTouchEnd(id: number) {
        if (this.isDead) return;
        if (this.inputs.has(id)) {
            this.scene.remove(this.inputs.get(id)!.line);
            this.inputs.delete(id);
        }
        for (const item of this.objects) {
            item.removeInput(id);
        }
    }

    public handleTouchMove(id: number, x: number, y: number) {
        if (this.isDead) return;
        if (this.inputs.has(id)) {
            this.inputs.get(id)!.update(x, y);
        }
        this.getIntersects(id, x, y);
        for (const item of this.objects) {
            item.update(0);
        }
    }

    public clearTouches() {
        for (const id of this.inputs.keys()) {
            this.scene.remove(this.inputs.get(id)!.line);
            for (const item of this.objects) {
                item.removeInput(id, true);
            }
        }
        this.inputs.clear();
    }

    public getIntersects(id: number, x: number, y: number) {
        for (const item of this.objects) {
            if (item.hasInput(id)) {
                return;
            }
        }
        //check item
        if (this.board.HitTestItems(x, y)) return;
        let IsIn = false;
        for (const item of this.objects) {
            if (item.IsIn(x, y)) {
                if (this.inputs.get(id) === undefined) {
                    if (this.inputs.has(id)) {
                        this.inputs.delete(id);
                    }

                } else {
                    IsIn = true;
                    item.addInput(id, this.inputs.get(id)!);
                }
                break;
            }
        }

        if (!IsIn) {
            for (const item of this.objects) {
                item.removeInput(id);
            }

            if (this.objects.length < this.maxObject) {
                if (this.inputs.get(id) === undefined) {
                    if (this.inputs.has(id)) {
                        this.inputs.delete(id);
                    }
                    return;
                }
                const touch = new TouchItem(x, y, this.radius, this.timeout);
                this.objects.push(touch);
                touch.addInput(id, this.inputs.get(id)!);
                touch.onDestroy = (item) => {
                    this.scene.remove(item.circle);
                    this.scene.remove(item.circleBack);
                    if (this.isGameStarted) {
                        this.blob.SetNoTouch(true);
                        this.Play("fartleak_" + this.randomIntFromInterval(1, 2));
                    }
                    for (let i = 0; i < this.objects.length; i++) {
                        if (this.objects[i] == item) {
                            this.objects.splice(i, 1);
                            break;
                        }
                    }
                }
                //console.log("added!");
                this.scene.add(touch.circleBack);
                touch.circleBack.renderOrder = 200;
                this.scene.add(touch.circle);
                touch.circle.renderOrder = 201;

            }
        }
    }
    private radians_to_degrees(radians: number) {
        var pi = Math.PI;
        return radians * (180 / pi);
    }
    private get_angle(p1: THREE.Vector3, p2: THREE.Vector3): number {
        const dx = p2.x - p1.x;
        const dy = p2.y - p1.y;
        const theta = Math.atan2(dy, dx);
        let angle = this.radians_to_degrees(theta);
        if (angle < 0) {
            angle = 360 + angle;
        }
        return theta;
    }
}
